var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4C11.7761 4 12 4.22386 12 4.5V15.5C12 15.7761 11.7761 16 11.5 16H0.5C0.223858 16 0 15.7761 0 15.5V4.5C0 4.22386 0.223858 4 0.5 4H11.5ZM11 5H1V15H11V5ZM2.5 2H13.5C13.7455 2 13.9496 2.17688 13.9919 2.41012L14 2.5V13.5C14 13.7761 13.7761 14 13.5 14C13.2545 14 13.0504 13.8231 13.0081 13.5899L13 13.5V3H2.5C2.22386 3 2 2.77614 2 2.5C2 2.25454 2.17688 2.05039 2.41012 2.00806L2.5 2ZM4.5 0H15.5C15.7455 0 15.9496 0.176875 15.9919 0.410124L16 0.5V11.5C16 11.7761 15.7761 12 15.5 12C15.2545 12 15.0504 11.8231 15.0081 11.5899L15 11.5V1H4.5C4.22386 1 4 0.776142 4 0.5C4 0.25454 4.17687 0.0503916 4.41012 0.00805567L4.5 0Z",
    fill: "#007CB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73504 7.73504L5.08859 11.3815L3.44214 9.73504L3.3729 9.67718C3.17803 9.54219 2.9086 9.56147 2.73504 9.73504C2.53977 9.9303 2.53977 10.2469 2.73504 10.4421L4.73504 12.4421L4.80428 12.5C4.99915 12.635 5.26858 12.6157 5.44214 12.4421L9.44214 8.44214L9.5 8.3729C9.635 8.17803 9.61571 7.9086 9.44214 7.73504C9.24688 7.53977 8.9303 7.53977 8.73504 7.73504Z",
    fill: "#007CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkAction);
export default __webpack_public_path__ + "static/media/bulk-action.8a070699478c0be1d41532bc5058ba48.svg";
export { ForwardRef as ReactComponent };